import Link from "next/link";
import clsx from "clsx";
// styles
import styles from "./Button.module.scss";
const buttonStyles = {
  solid: "border-0",
  outline: "border-0",
};
const baseStyles = {
  solid:
    "group box-border inline-flex items-center justify-center py-2 px-4 text-base font-bold focus-visible:outline-2 focus-visible:outline-offset-2",
  outline:
    "group box-border inline-flex ring-1 items-center justify-center text-base py-2 px-4 font-bold ",
};
const variantStyles = {
  solid: {
    pri: "bg-pri text-white hover:bg-hov hover:text-white active:bg-hov/50 focus-visible:outline-pri",
    sec: "bg-sec text-white hover:bg-hov hover:text-white active:bg-hov/50 focus-visible:outline-sec",
    ter: "bg-ter text-white hover:bg-hov hover:text-white active:bg-hov/50 focus-visible:outline-ter",
  },
  outline: {
    pri: "ring-pri text-pri hover:ring-hov hover:text-hov active:bg-hov/50 focus-visible:outline-pri",
    sec: "ring-sec text-sec hover:ring-hov hover:text-hov active:bg-hov/50 focus-visible:outline-sec",
    ter: "ring-ter text-ter hover:ring-hov hover:text-hov active:bg-hov/50 focus-visible:outline-ter",
    qua: "ring-ter text-txt-base hover:ring-hov hover:text-hov active:bg-hov/50 focus-visible:outline-ter ring-bdc-base",
  },
};
const textStyles = {
  light:
    "text-link hover:text-hov active:text-hov/80 focus-visible:outline-2 focus-visible:outline-offset-2",
  mono: "text-txt-base hover:text-hov active:text-hov/80 focus-visible:outline-2 focus-visible:outline-offset-2",
  dark: "text-white hover:text-hov active:text-hov/80 focus-visible:outline-2 focus-visible:outline-offset-2",
};
const variantTextStyles = {
  light: {
    pp: "text-txt-base",
    p: "underline",
    f: "font-bold",
    ff: "font-bold underline",
  },
  mono: {
    pp: "text-txt-base",
    p: "underline",
    f: "font-bold",
    ff: "font-bold underline",
  },
  dark: {
    pp: "",
    p: "underline",
    f: "font-bold",
    ff: "font-bold underline",
  },
};
export function TLink({
  variant = "light",
  color = "pp",
  href,
  className,
  ...props
}) {
  return (
    <Link href={href}>
      <a
        className={clsx(
          textStyles[variant],
          variantTextStyles[variant][color],
          className
        )}
        {...props}
      />
    </Link>
  );
}
export function Button({
  variant = "solid",
  color = "pri",
  className,
  ...props
}) {
  return (
    <button
      className={clsx(
        buttonStyles[variant],
        baseStyles[variant],
        variantStyles[variant][color],
        className
      )}
      {...props}
    />
  );
}
export function ButtonLink({
  variant = "outline",
  color = "pri",
  href,
  className,
  ...props
}) {
  return (
    <Link href={href}>
      <a
        className={clsx(
          baseStyles[variant],
          variantStyles[variant][color],
          className
        )}
        {...props}
      />
    </Link>
  );
}
